var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.6666C21.337 13.6666 20.7011 13.93 20.2322 14.3989C19.7634 14.8677 19.5 15.5036 19.5 16.1666V22C19.5 22.663 19.7634 23.2989 20.2322 23.7677C20.7011 24.2366 21.337 24.5 22 24.5C22.663 24.5 23.2989 24.2366 23.7678 23.7677C24.2366 23.2989 24.5 22.663 24.5 22V16.1666C24.5 15.5036 24.2366 14.8677 23.7678 14.3989C23.2989 13.93 22.663 13.6666 22 13.6666Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8333 20.3334V22C27.8333 23.5471 27.2187 25.0309 26.1247 26.1248C25.0308 27.2188 23.5471 27.8334 22 27.8334C20.4529 27.8334 18.9691 27.2188 17.8752 26.1248C16.7812 25.0309 16.1666 23.5471 16.1666 22V20.3334",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.8334V30.3334",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.60054489d1671b314e26a07b10898086.svg";
export { ForwardRef as ReactComponent };